<template>
  <div>
    <div class="flex cursor-pointer" @click="isOpen = !isOpen">
      <a :href="item.value" class="text-black font-bold text-16 leading-1.2 uppercase" :target="item.target">
        <h2>{{ item.name }}</h2>
      </a>
      <button v-if="hasSubMenu" class="align-middle focus:outline-none ml-auto">
        <span class="sr-only">Expand</span>
        <i class="fal fa-fw fa-sm" :class="openIcon"></i>
      </button>
    </div>
    <ul v-if="hasSubMenu" v-show="isOpen" class="border-l border-light-gray p-16">
      <li
        v-for="child in subMenuItems"
        class="mb-16 last:mb-0">
        <a :href="child.value"
          class="text-black text-16 leading-1.2"
          :target="child.target">
          <h3>{{ child.name }}</h3>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    open: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      menu: jsonFromPage('#data-navbar-menu'),
      isOpen: this.open,
    }
  },

  computed: {
    hasSubMenu () {
      return this.itemChildren.length > 0
    },

    openIcon () {
      return this.isOpen ? 'fa-chevron-down' : 'fa-chevron-right'
    },

    itemChildren () {
      return this.item.children.filter(child => child.enabled)
    },

    subMenuItems () {
      return this.itemChildren.find(item => item.children.filter(child => child.enabled).length > 0)?.children ||
        this.itemChildren
    },
  },
}
</script>
